var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"img",class:_vm.previewClass,attrs:{"src":_vm.previewData.preview_path},on:{"load":_vm.loaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }